import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface MetaTagsProps {
  title: string;
  description: string;
  keywords: string;
  image: string;
  url: string;
  author?: string;
  twitterCardType?: 'summary' | 'summary_large_image' | 'app' | 'player';
  type: string;
}

export const MetaTags = ({
  title,
  description,
  keywords,
  image,
  url,
  author = 'we.CONECT Global Leaders Group',
  twitterCardType = 'summary_large_image',
  type,
}: MetaTagsProps) => {
  const { i18n } = useTranslation();

  return (
    <Helmet>
      {/* General */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={author} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta
        property="og:locale"
        content={i18n.language === 'en' ? 'en_US' : 'de_DE'}
      />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content={twitterCardType} />
    </Helmet>
  );
};
